<template>
  <div class="multiFilter">
    <div class="ftl">
      <span class="_title" @click="toggle(one)">{{filter.filter(i=>i.selected)[0]?filter.filter(i=>i.selected)[0].title:''}}</span>
      <img :src="one.expand ? icons.up : icons.down" alt="icons"  @click="toggle(one)">
      <div class="_list" v-show="one.expand">
        <div class="_item" v-for="(i, d) in filter" :key="d" @click="select(i, filter, one)">
          <span :title="i.title">{{i.title}}</span>
          <img v-show="i.selected" src="@assets/img/common/select.svg" alt="right">
        </div>
      </div>
    </div>
    <div class="ftl" v-show="two.list.length > 0">
      <span class="_title" @click="toggle(two)">{{two.list.filter(i=>i.selected)[0]?two.list.filter(i=>i.selected)[0].title:''}}</span>
      <img :src="two.expand ? icons.up : icons.down" alt="icons"  @click="toggle(two)">
      <div class="_list" v-show="two.expand">
        <div class="_item" v-for="(i, d) in two.list" :key="d" @click="select(i, two.list, two)">
          <span :title="i.title">{{i.title}}</span>
          <img v-show="i.selected" src="@assets/img/common/select.svg" alt="right">
        </div>
      </div>
    </div>
    <!-- <div class="ftl"></div>  三级条件，预留 -->
  </div>
</template>

<script>

export default {
  name: "multiFilter", // 多级选择组件，单行
  props:{
    filter: Array
  },
  watch: {
    filter: {
      deep: true,
      handler: function (n, o) {
        // 根据第一项的数据决定是否展示第二项
        n.forEach(i => {
          if (i.selected) {
            this.two.list = i.list || []
          }
        })
      }
    }
  },
  data() {
    return {
      icons: {
        up: require('@assets/img/interview/up.svg'),
        down: require('@assets/img/interview/down.svg')
      },
      one: {
        selected: {},
        expand: false
      },
      two: {
        selected: {},
        expand: false,
        list: []
      }
    }
  },

  methods: {
    resetSelect() {
      // 恢复选中数据
      this.one.selected = ''
      this.two.selected = ''
    },
    getSelect() {
      // 计算得出被选的选项
      this.resetSelect()

      this.filter.forEach((i) => {
        if (i.selected) {
          this.one.selected = i.key
          i.list && i.list.forEach((j) => {
            if (j.selected) {
              this.two.selected = j.key
            }
          })
        }
      })

      this.$emit('getData', {
        one: {
          key: this.one.selected || ''
        },
        two: {
          key: this.two.selected || ''
        }
      })
    },
    toggle(item) {
      this.$set(item, 'expand', !item.expand)
    },
    select(item, list, section) {
      // 选择列表项
      list.forEach(i => {
        i.selected = false
      })

      console.log('select', item.key)
      setTimeout(() => {
        this.$nextTick(() => {
          this.$set(item, 'selected', true)

          this.getSelect()

          section.expand = false
        })
      }, 0)
    },
  }
};
</script>
<style lang="less" scoped>
  @import '../assets/css/global.less';

  .multiFilter {
    flex: 1;
    height: 30px;
    display: flex;
    .ftl {
      position: relative;
      width: 200px;
      border: 1px solid #dcdcdc;
      border-radius:  4px;
      height: 30px;
      margin-right: 24px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      ._title {
        flex: 1;
        font-size: 14px;
        color: @sub;
        text-align: center;
        cursor: pointer;
      }
      ._list {
        z-index: 5;
        position: absolute;
        top: 40px;
        left: 0;
        width: 200px;
        border-radius: 4px;
        background-color: #fff;
        padding: 10px 0;
        max-height: 196px;
        overflow-y: auto;
        ._item {
          height: 30px;
          font-size: 14px;
          display: flex;
          align-items: center;
          cursor: pointer;
          padding: 0 20px;
          span {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          &:hover {
            background-color: rgba(65, 180, 140, 0.15);
          }
        }
        &::-webkit-scrollbar {
          width: 4px;
          height: 0;
          margin-right: 2px;
        }
        &::-webkit-scrollbar-thumb {
          background: rgba(5, 15, 15, 0.3);
          border-radius: 4px;
        }
      }
    }
    .ftl:last-child {
      margin-right: 0;
    }
  }
</style>
